import React from 'react';
import { Progress } from 'reactstrap';

export const riskLevelBadge = (riskLevel) => {
  if (!riskLevel) {
    return (
      <p className="py-1 text-nowrap mb-0">
        <i className="fas fa-exclamation-circle text-danger fa-lg"></i>
        <a href="#" className="text-info pl-1">Completar</a>
      </p>
    );
  }

  return (
    <span
      className="badge badge-soft"
      style={{
        backgroundColor: `${riskLevel.hex_color}1A`,
        color: riskLevel.hex_color,
        border: `1px solid ${riskLevel.hex_color}`
      }}
    >
      {riskLevel.name}
    </span>
  );
};

export const aasmStateBadge = (state, module_name) => {
  if (!state) return null;

  let badgeAttributes = {};

  if (state === 'planned') {
    badgeAttributes = {
      className: "badge badge-soft badge-soft",
      style: {
        backgroundColor: 'rgba(253, 126, 20, 0.1)',
        color: 'var(--orange)',
        border: '1px solid var(--orange)'
      }
    }
  } else if (state === 'pending') {
    badgeAttributes = {
      className: "badge badge-soft badge-soft-warning",
    }
  } else if (state === 'in_process' || state === 'processing') {
    badgeAttributes = {
      className: "badge badge-soft badge-soft-info",
    }
  } else if (state === 'overdue' || state === 'failed') {
    badgeAttributes = {
      className: "badge badge-soft badge-soft-danger",
    }
  } else if (state === 'completed') {
    badgeAttributes = {
      className: "badge badge-soft badge-soft-success",
    }
  } else if (state === 'completed_errors') {
    badgeAttributes = {
      className: "badge badge-soft badge-soft-secondary",
    }
  }

  return (
    <span {...badgeAttributes}>
      {I18n.t(`activerecord.attributes.${module_name}.aasm_state.${state}`) || I18n.t('no_entry')}
    </span>
  );
};

export const activityProgressBar = (activity) => {
  return (
    <div style={{
      position: 'relative',
    }}>
      <Progress
        animated
        color="primary"
        value={activity?.progress || 0}
      />
      <span style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        fontSize: '13px',
        fontWeight: '600',
        color: '#ffffff',
        textShadow: '0px 0px 3px #000000',
      }}>
        {activity?.progress || 0}%
      </span>
    </div>
  );
};

export const evidenceFileAasmStateBadge = (row) => {
  const {
    last_evidence_file: evidenceFile,
    policy,
  } = row;

  let badgeAttributes = {};

  if (evidenceFile?.aasm_state === 'pending' && policy?.review || evidenceFile?.aasm_state === 'in_review') {
    badgeAttributes = {
      className: "badge badge-soft badge-soft-info",
      label: 'En revisión',
    }
  } else if (evidenceFile?.aasm_state === 'accepted') {
    badgeAttributes = {
      className: "badge badge-soft badge-soft-success",
      label: 'Aceptada',
    }
  } else {
    badgeAttributes = {
      className: "badge badge-soft badge-soft-warning",
      label: 'Pendiente',
    }
  }

  return <span {...badgeAttributes}>{badgeAttributes.label}</span>;
};